import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { DepartmentDisplay } from '@modules/department/models/department-display';
import { LabelPackDisplay } from '@modules/department/models/label-pack-display';
import { FILTER_TEMPLATES, FilterBarService } from '@modules/filters/filter-bar.service';
import { FilterBarComponent } from '@modules/filters/filter-bar/filter-bar.component';
import { Store } from '@ngrx/store';
import { TuiButton } from '@taiga-ui/core';
import { Observable, of, switchMap } from 'rxjs';
import { MenuAction } from 'src/app/shared/models/menu-actions/menu-action';
import { selectLabelPacks } from 'src/app/shared/store/labels/labels.selectors';
import { LabelTableComponent } from '../../../label/label-table/label-table.component';
import { DepartmentAdminService } from '../department-admin/department-admin.service';
import { DepartmentLabelsAdminService } from './department-labels-admin.service';
import { TuiAnimated } from '@taiga-ui/cdk';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';

@Component({
  hostDirectives: [TuiAnimated],
  selector: 'pxc-department-labels-admin',
  imports: [EmptyStateComponent, CommonModule, LabelTableComponent, TuiButton, FilterBarComponent, TranslocoDirective],
  providers: [
    DepartmentLabelsAdminService,
    FilterBarService,
    {
      provide: FILTER_TEMPLATES,
      useValue: of([]),
    },
  ],
  templateUrl: './department-labels-admin.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentLabelsAdminComponent {
  private readonly departmentAdminService = inject(DepartmentAdminService);
  private readonly departmentLabelsAdminService = inject(DepartmentLabelsAdminService);
  private readonly store = inject(Store);

  readonly department$: Observable<DepartmentDisplay> = this.departmentAdminService.department$;
  readonly labelPacks$: Observable<LabelPackDisplay[]> = this.departmentAdminService.params$.pipe(
    switchMap(({ departmentId, clientCode }) => this.store.select(selectLabelPacks(departmentId, clientCode))),
  );

  readonly actions: MenuAction[] = [];

  addLabels(labelPackId: number): void {
    this.departmentLabelsAdminService.createLabels(labelPackId);
  }
}
